// Product configuration — change the app name in one place.
// All tunable constants live here so renaming or re-tuning does not
// require editing scattered files.
export const PRODUCT = {
  name: 'RadioAtlas',
  tagline: 'Dünya radyosunu haritada keşfet',
} as const;

// Smart Tune tunables (kept within the spec ranges).
export const SMART_TUNE = {
  debounceMs: 1200,
  // meaningful geographic movement before auto-switching (km)
  movementThresholdKm: 25,
  // zoom delta that counts as a meaningful move
  zoomDeltaThreshold: 1,
  // do not switch if current station is within this top fraction
  currentStationKeepFraction: 0.2,
  // cooldown after a manual selection (ms)
  manualCooldownMs: 5 * 60 * 1000,
} as const;

// Map zoom bands — configurable.
export const MAP_ZOOM_BANDS = {
  global: { min: 0, max: 2.9 },
  country: { min: 3, max: 5.9 },
  region: { min: 6, max: 8.9 },
  station: { min: 9, max: 22 },
} as const;

// Audio engine tunables.
export const AUDIO = {
  loadTimeoutMs: 12_000,
  retryAttempts: 2,
} as const;

// Radio-Browser API + sync tunables.
export const RADIO_BROWSER = {
  apiBase: 'https://de1.api.radio-browser.info/json',
  syncBatchSize: 5000,
  streamCheckBatchSize: 50,
  streamCheckTimeoutMs: 8000,
} as const;
